import { useState } from "react";
import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const IMG = "/assets/img/hero";

export default function Banner() {
    const { t } = useTranslation();
    const [keyword, setKeyWord] = useState('');
    const selector = useSelector((state) => state.appearanceReducer);
    const appearanceData = selector?.data;
    const navigate = useNavigate()
    const location = useLocation();
    const isAppRoute = location.pathname.startsWith("/app");
    const prefix = isAppRoute ? "/app" : "";
    const search_course = () => {
        navigate(`${prefix}/all-courses?keyword=${encodeURIComponent(keyword)}`);
    }

    return (
        <section className="banner-area hero">
            <div className="container">
                <div className="row align-items-center gy-5">
                    <div className="col-lg-6">
                        <div className="banner-content">
                            <span className="hero-eyebrow">
                                <span className="hero-eyebrow-dot" /> {t('banner.eyebrow')}
                            </span>
                            <h1 className="hero-title">{appearanceData?.header_title ? appearanceData.header_title : t('banner.default_title')}</h1>
                            <p className="hero-subtitle">{appearanceData?.header_sub_title ? appearanceData.header_sub_title : t('banner.default_subtitle')}</p>

                            <div className="hero-search d-flex align-items-center">
                                <div className="flex-grow-1 banner-content-search-inputBox position-relative">
                                    <input onKeyUp={(e) => setKeyWord(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { search_course() } }} type="text" className="form-control form-control-lg banner-form-input" placeholder={t('banner.search_placeholder')} aria-label={t('banner.search_placeholder')} />
                                    <div className="banner-content-search-icon position-absolute">
                                        <i className="fa-light fa-search" />
                                    </div>
                                </div>
                                <button type="button" onClick={() => search_course()} className="flex-shrink-0 btn btn-lg getStart-btn">{t('banner.get_started')}</button>
                            </div>

                            <ul className="hero-points">
                                <li><span className="hero-point-icon hero-point-icon--1"><i className="fa-solid fa-check" /></span>{t('banner.point_1')}</li>
                                <li><span className="hero-point-icon hero-point-icon--2"><i className="fa-solid fa-check" /></span>{t('banner.point_2')}</li>
                                <li><span className="hero-point-icon hero-point-icon--3"><i className="fa-solid fa-check" /></span>{t('banner.point_3')}</li>
                            </ul>

                            <Link to={`${prefix}/all-courses`} className="Explore-link">
                                {t('banner.explore_courses')} <i className="fa-light fa-arrow-right" />
                            </Link>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="hero-visual">
                            <div className="hero-photo hero-photo--main">
                                <img src={`${IMG}/hero-tutor.jpg`} alt={t('banner.tutor_alt')} fetchpriority="high" />
                            </div>
                            <div className="hero-photo hero-photo--side">
                                <img src={`${IMG}/hero-learner.jpg`} alt={t('banner.learner_alt')} />
                            </div>

                            <div className="hero-badge hero-badge--live" aria-hidden="true">
                                <span className="hero-live-dot" /> {t('banner.live_lesson')}
                            </div>

                            <div className="hero-badge hero-badge--tutor" aria-hidden="true">
                                <div className="hero-badge-head">
                                    <strong>{t('banner.tutor_name')}</strong>
                                    <span><i className="fa-solid fa-star" /> 4.9</span>
                                </div>
                                <span className="hero-badge-sub">
                                    <i className="fa-light fa-graduation-cap" /> {t('banner.tutor_subject')}
                                </span>
                            </div>

                            <div className="hero-badge hero-badge--progress" aria-hidden="true">
                                <span className="hero-progress-icon"><i className="fa-solid fa-trophy" /></span>
                                <div>
                                    <strong>{t('banner.learner_name')}</strong>
                                    <span className="hero-badge-sub">{t('banner.learner_note')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
